export default __webpack_public_path__ + "static/logo55-af88dbb24bd7db2ff260726c3e407c36.svg";